import React from 'react';
import PropTypes from 'prop-types';
import ProductFilter from '../../filters/ProductFilter';
import ProductCard from '../../common/ProductCard';
import AssignTo from '../../filters/AssignTo';
import GridContainerProduct from '../../../components/grid-container/GridContainerProduct';
import EmptyData from '../../common/EmptyData';
import Search from '../../common/Search';
import { StaticFilters } from '../../../constants/staticFilters';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { showMSRPPrices } from '../../../constants/featureFlag';

function AssignNewProducts(props) {
  const isShowWSRPPricesEnabled = useFeatureFlag(showMSRPPrices, false);
  const onCheckProduct = (checked, value) => {
    if (checked) {
      props.check(value);
    } else {
      props.uncheck(value);
    }
  };

  const handlePageClick = (data) => {
    props.setPage(props.perPage * data.selected);
  };

  const isChecked = (model) => {
    return props.checked.hasOwnProperty(model);
  };

  const products = () => {
    const { data } = props;

    if (!data.length) {
      return <EmptyData text={'No data found by your request. Please try to change searching requirements.'} />;
    }

    return data.map((item) => (
      <div className="product" key={item.model}>
        <ProductCard
          product={item}
          checkbox
          slider={props.showSlider}
          onCheck={onCheckProduct}
          checked={isChecked(item.model)}
          assignedTo={props.assignedTo}
          shouldAllowUserToDoActions={true}
          isShowWSRPPricesEnabled={isShowWSRPPricesEnabled}
        />
      </div>
    ));
  };

  return (
    <div className="row vertical-indent">
      <div className="column_filter">
        <Search searchQuery={props.searchQuery} search={props.productSearch} />

        <ProductFilter
          filters={props.filters}
          staticFilters={props.staticFilters}
          currentFilters={props.currentFilters}
          currentFilterSearches={props.currentFilterSearches}
          setFilter={props.setFilter}
          setFilterSearch={props.setFilterSearch}
        />
      </div>
      <GridContainerProduct
        isLoading={props.isLoadingProducts}
        pageCount={props.pageCount}
        handlePageClick={handlePageClick}
        currentPage={props.offset / props.perPage}
      >
        {products()}
      </GridContainerProduct>
      <AssignTo
        retailers={props.retailers}
        submit={props.submit}
        productsCount={Object.keys(props.checked).length}
        canUserDoActions={props.canUserDoActions}
      />
    </div>
  );
}

export default AssignNewProducts;

AssignNewProducts.defaultProps = {
  setPage: null,
  check: undefined,
  uncheck: undefined,
  checked: {},
  showSlider: true,
  assignedTo: true,
  isLoadingProducts: false,
  staticFilters: [StaticFilters.HAS_INVENTORY, StaticFilters.ASSIGNED_TO_RETAILERS],
};

AssignNewProducts.propTypes = {
  pageCount: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  setFilter: PropTypes.func.isRequired,
  setFilterSearch: PropTypes.func,
  perPage: PropTypes.number.isRequired,
  setPage: PropTypes.func,
  retailers: PropTypes.array.isRequired,
  check: PropTypes.func,
  uncheck: PropTypes.func,
  checked: PropTypes.object,
  productSearch: PropTypes.func.isRequired,
  showSlider: PropTypes.bool,
  submit: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  assignedTo: PropTypes.bool,
  offset: PropTypes.number.isRequired,
  isLoadingProducts: PropTypes.bool,
  staticFilters: PropTypes.array,
  filters: PropTypes.object.isRequired,
  currentFilters: PropTypes.object.isRequired,
  currentFilterSearches: PropTypes.object.isRequired,
};
